@for (cfg of skeletonConfigs(); track cfg) {
  <div
    class="skeleton"
    [class]="itemClassName()"
    [style.inline-size]="cfg.width"
    [style.block-size]="cfg.height"
  ></div>
}
